var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div class=\"schema container\">\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <h2 class=\"page-header\"></h2>\n    </div>\n  </div>\n  <div class=\"schema-view\"></div>\n</div>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}